import { Breadcrumbs, Link, Skeleton, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export type BreadcrumbItem = {
  label: string | React.ReactNode;
  to?: string;
};

type PageBreadcrumbProps = {
  isLoading?: boolean;
  items: BreadcrumbItem[];
};

export const PageBreadcrumb = ({
  isLoading = false,
  items,
}: PageBreadcrumbProps) => {
  if (isLoading) {
    return <Skeleton variant="rounded" height={24} width={220} />;
  }

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {items.map((item, index) => {
        if (item.to) {
          return (
            <Link
              key={index}
              component={RouterLink}
              to={item.to}
              underline="hover"
              color="inherit"
            >
              {item.label}
            </Link>
          );
        }

        return (
          <Typography key={index} component="span">
            {item.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};
